import { GroupVisitControllerApi, GroupVisitPatient } from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  groupVisitId: string;
  groupVisitPatient: GroupVisitPatient;
};

/**
 * @author Rajkumar Rathod
 */
export const useAddGroupVisitPatients = () =>
  useMutationWithLoading(async ({ groupVisitId, groupVisitPatient }: Params) =>
    new GroupVisitControllerApi(getConfigObject()).addPatientsToGroupVisit(
      groupVisitId,
      groupVisitPatient,
      getXtenantId()
    )
  );
